import {get} from 'lodash';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useToasts} from 'react-toast-notifications';
import {Form} from 'semantic-ui-react';
import config from '../../config/config';
import {ContentType} from '../../const/enums/Content';
import {Content} from '../../const/interfaces/Content';
import {User} from '../../const/interfaces/User';
import AxiosHelper from '../../util/AxiosHelper';
import {getModerationField} from '../../util/ModerationHelper';
import ContentThumbnail from './ContentThumbnail';

export interface SoundCloudProps {
  content: Content;
  handleChange: any;
  comingSoon?: boolean;
}

const SoundCloud = ({content, handleChange, comingSoon}: SoundCloudProps) => {
  const loggedInUser: User = useSelector((state) => state.loggedInUser).data;
  const {addToast} = useToasts();

  const field = comingSoon ? `comingSoonContent.primaryContent` : `primaryContent`;
  const url = get(
    content,
    getModerationField(content, `${field}.${ContentType.SOUNDCLOUD}.url`),
  );
  const existingThumbnail = get(
    content,
    getModerationField(
      content,
      `${field}.${ContentType.SOUNDCLOUD}.mediaUrl`,
    ),
  );

  const [thumbnailVideoUrl, setThumbnailVideoUrl] = useState(url);
  const [thumbnail, setThumbnail] = useState(existingThumbnail);


  useEffect(() => {
    if (url && url !== thumbnailVideoUrl) {
      setThumbnailVideoUrl(url);
      (async () => {
        try {
          if (loggedInUser && loggedInUser.token) {
            const axiosHelper = new AxiosHelper(loggedInUser.token);
            const contentData = await axiosHelper.get(
              `${config.api}/content/provider/soundcloud`,
              {
                soundCloudUrl: url,
              },
            );
            let thumbnail;
            if (contentData) {
              thumbnail = contentData.data.thumbnail_url;
              handleChange(
                `${field}.${ContentType.SOUNDCLOUD}.mediaUrl`,
                {
                  value: thumbnail,
                },
              );
              setThumbnail(thumbnail);
            }
          }
        } catch (e) {
          return addToast(`Thumbnail could not be found.`, {
            appearance: 'warning',
            autoDismiss: true,
          });
        }
      })();
    }
  }, [url, handleChange, thumbnailVideoUrl, addToast, loggedInUser, field]);

  if (!content || !handleChange) {
    return null;
  }

  return (
    <div className={'ContentType'}>
      <div className={'ContentTypeInputs'}>
        <Form.Field required>
          <label>SoundCloud URL</label>
          <Form.Input
            placeholder={
              'Enter a SoundCloud URL e.g. https://soundcloud.com/manicstreetpreachers/if-you-tolerate-this-your-1'
            }
            value={
              get(
                content,
                getModerationField(
                  content,
                  `${field}.${ContentType.SOUNDCLOUD}.url`,
                ),
              ) || ''
            }
            onChange={(e, data) =>
              handleChange(`${field}.${ContentType.SOUNDCLOUD}.url`, data)
            }
            error={
              !get(
                content,
                getModerationField(
                  content,
                  `${field}.${ContentType.SOUNDCLOUD}.url`,
                ),
              )
            }
          />
        </Form.Field>
      </div>

      <div>
        <ContentThumbnail
          content={content}
          handleChange={handleChange}
          thumbnail={thumbnail}
          comingSoon={comingSoon}
        />
      </div>
    </div>
  );
};

export default SoundCloud;
